function Campagne2024(el) {
    this.el = el;
    this.innerWrapperEl = this.el.querySelector('.jsInnerWrapper');
    this.innerEl = this.el.querySelector('.jsInner');
    this.prevBtnEl = this.el.querySelector('.jsPrevBtn');
    this.nextBtnEl = this.el.querySelector('.jsNextBtn');
    this.colWidth = this.el.querySelector('.jsCol').offsetWidth;
    this.colCorrection = 0.8;
    this.modalEl = this.el.querySelector('.jsModal');
    this.endScreenEl = this.el.querySelector('.jsEndScreen');
    this.endScreenVisible = false;

    // Prepare the inner element for the transition
    this.innerEl.style.transform = `translateX(0px)`;

    this.setColWidth();
    this.setCentered();
    this.initEventListeners();
    this.checkBoundary(0);
    this.initModal();
}

Campagne2024.prototype.moveInnerEl = function (direction) {
    const windowWidth = window.innerWidth;
    const innerElWidth = this.innerEl.offsetWidth;

    const currentPosition = this.innerEl.getBoundingClientRect().x;
    let newPosition = 0;
    const percentage = Math.abs(currentPosition / (innerElWidth - windowWidth)) * 100;

    if (this.el.classList.contains('centered')) {
        if (direction === 'next') this.showEndScreen();
        else this.hideEndScreen();

        return;
    }

    if (direction === 'next') {
        if (percentage >= 100) {
            this.showEndScreen();
            return;
        }
        else {
            if (percentage < 49) newPosition = -((this.colWidth * 1.5) - (windowWidth / 2)); // Move to col 2
            else newPosition = -((this.colWidth * 2.5) - (windowWidth / 2)); // Move to col 3    

            // Prevent position overflow
            if (newPosition <= -(innerElWidth - windowWidth)) newPosition = -(innerElWidth - windowWidth);
        }
    }
    else if (direction === 'prev') {
        if (this.endScreenVisible) {
            this.hideEndScreen();
            return;
        }

        if (percentage > 51) newPosition = -((this.colWidth * 1.5) - (windowWidth / 2)); // Move to col 2
        else newPosition = -((this.colWidth / 2) - (windowWidth / 2)); // Move to col 1

        // Prevent position overflow
        if (newPosition >= 0) newPosition = 0;
    }

    gsap.to(this.innerEl, { duration: 1.5, x: newPosition, ease: 'power2.out' });
    this.checkBoundary(Math.round(newPosition));
};

Campagne2024.prototype.checkBoundary = function (currentPosition) {
    const windowWidth = window.innerWidth;
    const innerElWidth = this.innerEl.offsetWidth;

    if (currentPosition === 0 && window.innerWidth >= (this.colWidth * this.colCorrection) && window.innerWidth < this.colWidth) { // We use the centered view, but we need to center the first view
        this.innerEl.style.transform = `translateX(-${(this.colWidth * 0.5) - (windowWidth / 2)}px)`;
    }
    else {
        // Make sure we don't go beyond the boundaries on screen resize
        if (currentPosition >= 0) this.innerEl.style.transform = `translateX(0px)`;
        else if (currentPosition <= -(innerElWidth - windowWidth)) this.innerEl.style.transform = `translateX(${-(innerElWidth - windowWidth)}px)`;
    }

    // Enable or disable the prev button
    // if (currentPosition >= 0) this.prevBtnEl.classList.add('hidden');
    // else this.prevBtnEl.classList.remove('hidden');

    // Enable or disable the next button
    // if (currentPosition <= -(innerElWidth - windowWidth)) this.nextBtnEl.classList.add('hidden');
    // else this.nextBtnEl.classList.remove('hidden');

    // Activate the correct segment
    const percentage = Math.abs(currentPosition / (innerElWidth - windowWidth)) * 100;
    this.activateSegment(this.getSegmentByPercentage(percentage));
};

Campagne2024.prototype.showEndScreen = function() {
    const duration = 0.75;
    this.endScreenVisible = true;

    gsap.timeline()
        .set(this.endScreenEl, { xPercent: 100 })
        .add(() => this.endScreenEl.classList.add('is-active'))
        .to(this.endScreenEl, { duration: duration, xPercent: 0, ease: 'power2.inOut' })
        .to(this.innerWrapperEl, { duration: duration, xPercent: -20, ease: 'power2.inOut' }, '-=' + duration);
};

Campagne2024.prototype.hideEndScreen = function() {
    const duration = 0.75;
    this.endScreenVisible = false;

    gsap.timeline()
        .to(this.endScreenEl, { duration: duration, xPercent: 100, ease: 'power2.inOut' })
        .to(this.innerWrapperEl, { duration: duration, xPercent: 0, ease: 'power2.inOut' }, '-=' + duration)
        .add(() => this.endScreenEl.classList.remove('is-active'));
};

Campagne2024.prototype.activateSegment = function (segment) {
    this.el.classList.remove('segment-1');
    this.el.classList.remove('segment-2');
    this.el.classList.remove('segment-3');

    this.el.classList.add('segment-' + segment);
};

Campagne2024.prototype.getSegmentByPercentage = function (percentage) {
    if (percentage < 40) return 1;
    if (percentage < 80) return 2;
    return 3;
};

Campagne2024.prototype.initEventListeners = function () {
    this.prevBtnEl.addEventListener('click', this.onPrevBtnClick.bind(this));
    this.nextBtnEl.addEventListener('click', this.onNextBtnClick.bind(this));

    window.addEventListener('resize', () => {
        this.setColWidth();
        this.setCentered();
        this.checkBoundary(this.innerEl.getBoundingClientRect().x);
    });

    this.endScreenEl.addEventListener('click', e => {
        if (e.target.classList.contains('jsPrevBtn')) {
            e.preventDefault();
            this.hideEndScreen();
        }
    });
};

Campagne2024.prototype.setCentered = function () {
    if (window.innerWidth > this.innerEl.offsetWidth) {
        this.el.classList.add('centered');
        this.innerEl.style.transform = `translateX(0)`;
    }
    else {
        this.el.classList.remove('centered');
    }
};

Campagne2024.prototype.onPrevBtnClick = function () {
    this.moveInnerEl('prev');
};

Campagne2024.prototype.onNextBtnClick = function () {
    this.moveInnerEl('next');
};

Campagne2024.prototype.setColWidth = function () {
    this.colWidth = this.el.querySelector('.jsCol').offsetWidth;
};

Campagne2024.prototype.initModal = function () {
    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsModalTrigger')) {
            e.preventDefault();

            const text = e.target.dataset.text ? JSON.parse(e.target.dataset.text) : '';
            const url = e.target.dataset.url;
            const btnText = e.target.dataset.btnText;

            const contentEl = this.modalEl.querySelector('.jsContent');
            const btnEl = this.modalEl.querySelector('.jsBtn');

            contentEl.innerHTML = text;
            btnEl.href = url;
            btnEl.innerHTML = btnText;

            this.showModal();
        }
    });

    this.modalEl.addEventListener('click', e => {
        if (e.target.classList.contains('jsClose')) {
            e.preventDefault();
            this.hideModal();
        }
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') {
            this.hideModal();
        }
    });
};

Campagne2024.prototype.showModal = function () {
    if (this.modalEl.classList.contains('is-active')) return;

    const innerEl = this.modalEl.querySelector('.jsInner');

    gsap.timeline()
        .set(this.modalEl, { opacity: 0 })
        .set(innerEl, { yPercent: 100 })

        .add(() => this.modalEl.classList.add('is-active'))

        .to(this.modalEl, { duration: 0.5, opacity: 1, ease: 'power2.inOut' })
        .to(innerEl, { duration: 0.5, yPercent: 0, ease: 'power2.out' }, '-=0.5');
};

Campagne2024.prototype.hideModal = function () {
    if (!this.modalEl.classList.contains('is-active')) return;

    const innerEl = this.modalEl.querySelector('.jsInner');

    gsap.timeline()
        .to(this.modalEl, { duration: 0.5, opacity: 0, ease: 'power2.inOut' })
        .to(innerEl, { duration: 0.5, yPercent: 100, ease: 'power2.out' }, '-=0.5')

        .add(() => this.modalEl.classList.remove('is-active'))
    ;
};

(function () {
    const campagneEl = document.querySelector('.jsCampagne2024');
    if (campagneEl) new Campagne2024(campagneEl);
})();